// extracted by mini-css-extract-plugin
export default {"article":"Article_article__xm+1s","references":"Article_references__WQNeY"};